let config = false;

if (config === false) {
  try {
    config = JSON.parse(document.getElementById('config').innerHTML);
  } catch (error) {
    // TODO: log this error on any errors log provider
    console && console.log(error); // eslint-disable-line
  }
}

export default {
  ...config,
};
